<script>

//import 'bootstrap'
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

//import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import Popper from 'popper.js'
//import 'bootstrap/dist/js/bootstrap.min.js'
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false


var pjson = require('../package.json');


import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faVideo, faUserFriends, faListAlt, faFileAlt, faGlobe, faPlayCircle, faHome, faPen, faArrowAltCircleRight, faSignOutAlt, faSignInAlt, faThumbsUp, faEdit, faTrashAlt, faTimes, faEye, faEyeSlash, faUser, faQrcode, faCamera, faThList, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
library.add( faBars, faVideo, faUserFriends, faListAlt, faFileAlt, faGlobe, faPlayCircle, faHome, faPen, faArrowAltCircleRight, faSignOutAlt, faSignInAlt, faThumbsUp, faEdit, faTrashAlt, faTimes, faEye, faEyeSlash, faUser, faQrcode, faCamera, faThList, faSyncAlt)
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";


import myLangs from './components/Common/LangSwitch.vue'
import myMenu from './components/Common/MainMenu.vue'
import mainVersion from './components/Common/MainVersion.vue'
import mainLogo from './components/Common/MainLogo.vue'



//general functions
import MixinGeneralFunct from './mixins/GeneralFunctions';


//data
import { logoutUser, getDataToLogin } from '@/services/serviceLogin';
import { loadAccessData, loadMenuItem, loadVersion } from '@/services/serviceCommon';



export default {
	name: 'App',
	mixins: [ MixinGeneralFunct ],
	components: {
		myLangs
		,myMenu
		,mainVersion
		,mainLogo
		,"font-awesome-icon":FontAwesomeIcon
		
	},
	
	directives: {
		focus: {
			// directive definition
			mounted(el) {
				el.focus()
			}
		}
	},
	data() {
		return {
			prefix:'',
			user:[],
			userData:[],
			
			auth:[],
			secData:[],
			params:[],

			version:'',
			versionAlert:false,
			versionApp:pjson.version,
			versionDB:'',
			versionCMS:'',

			actLangs:[],
			

			eventCounts:[{streams:0,documents:0,expo:0,program:0,speakers:0,records:0}],
			
			cookiesTime: 259200,
			event:[],
			
			alerts:[],
			
			menuItems:[],
			
			menuIsOpened:true,
			showPersonalmenu:false,
			
			t0:0,
			t1:0,
		
		}
	},
	
	mounted:function(){
		this.onLoadPage();
	},
	
	methods: {
		
		//default data
		onLoadPage:function(){
			
			getDataToLogin().then(response => {
				if(!response.statusText){

					this.userData = response.userData;
					this.user = response.user;
					
					if(!this.user.isReg){
						this.$router.push({ path: '/login' })
					}

				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			loadAccessData().then(response => {
				if(!response.statusText){
					this.secData = response.secData;
					this.auth = response.secData.auth;
					this.params = response.params;
					this.actLangs = response.actLangs;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			loadMenuItem().then(response => {
				if(!response.statusText){
					this.menuItems = response.mainMenu;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			loadVersion().then(response => {
				if(!response.statusText){
					this.versionDB = response.versionDB;
					this.versionCMS = response.versionCMS;
				
					if(this.versionDB!=this.versionApp || this.versionCMS!=this.versionApp || this.versionCMS!=this.versionDB){
						this.versionAlert = true;
					}else{
						this.version = response.versionDB;
					}
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},
		
		//zmena jazyka
		onChangeLang(e) {
			this.$i18n.locale=e;
		},
		
		//zobrazi osobne menu
		showPersonalMenu: function(){
			this.showPersonalmenu = this.showPersonalmenu===true?false:true;
		},
		
				
		//odhlasenie
		onLogOut:function(){
			
			logoutUser().then(response => {
				if(!response.statusText){
					
					this.user = response.userData;

					if(!this.user.isReg){
						this.$router.push({ path: '/login' })
						this.menuItems=[];
					}
					
				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});
			
		},
		
		//zobrazenie menu
		showHideMenu:function(){
			if(this.menuIsOpened){
				this.menuIsOpened=false;
			}else{
				this.menuIsOpened=true;
			}
		},
		
	
	},
		
	created(){
		if(localStorage.Lang!=null) this.$i18n.locale=localStorage.Lang; 
	},
}
</script>


<template>



<div class="wrapper">

        <nav id="sidebar" :class="{'active':!menuIsOpened}">
			<div class="select-lang bg-info"><myLangs :propActLang="$i18n.locale" @changeLang="onChangeLang" :langsData="actLangs"/></div>
			<div class="menu"><myMenu :menuData="menuItems" :propActLang="$i18n.locale" :params="params"/></div>

			<div class="sidebar-bottom"><mainLogo :params="params"></mainLogo></div>
			<div v-if='user.isReg' class="sidebar-version"><mainVersion :version="version" :versionDB="versionDB" :versionApp="versionApp" :versionCMS="versionCMS" :versionAlert="versionAlert"></mainVersion></div>
		</nav>

        <div id="content" :class="{'active':!menuIsOpened}">
		
				<div id="msg"></div>
				
				<div id="content-head" :class="{'active':!menuIsOpened}">
					<!--<div><div class='top-menu-box-left'><button type='button' id='sidebarCollapse' class='btn btn-login-style' v-on:click="showHideMenu()"><font-awesome-icon :icon="['fas', 'bars']" class='fa-login-style' /></button></div></div>-->

					<div class="burger" v-on:click="showHideMenu()">
						<div class="burger-content" :class="{'open':menuIsOpened}">
							<div class="burger-lines"></div>
						</div>
					</div>

					<!--<div v-if='helpboxData' v-on:click="showHelpbox()" class="top-menu-box-right">
						<a href="#"><i v-if="!showedHelpbox" class="fas fa-question fa-login-style"></i><i v-else class='fas fa-times fa-login-style'></i></a>
					</div>-->
					<div v-if='user.isReg' class='top-menu-box-right'><a v-on:click='showPersonalMenu()' href='#'><font-awesome-icon :icon="['fas', 'user']" class='fa-login-style' /></a></div>

					<div v-if="showPersonalmenu && user.isReg" id="personalMenu" class="personalMenu">
						<a :href="'/'+ params.appFolder +'user-change-password'"><p>Zmena údajov</p></a>
						<a v-on:click='onLogOut()' :title="$t('msgCore.SignOut')" href='#'><p>{{$t('msgCore.SignOut')}}</p></a>
					</div>
				</div>	
				
				<div id="content-main">
				
					<!-- zakladny zoznam -->
					
					<div class="container-fluid" >
						
						<router-view :auth="auth" :secData="secData" :params="params" :key="$route.fullPath" ></router-view>
						
					</div>
				</div>	
			
		</div>	
		
</div>



	
	


</template>

<style src="vue-multiselect/dist/vue3-multiselect.css"></style>

<style lang="scss">
	@import "./assets/scss/custom.scss";
</style>

<style lang="css">
	
	@import "./assets/css/all.min.css";
	@import "./assets/css/themePopper.css";
</style>